import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
import _ from "lodash";
import BaseLayout from './../../templates/base';
import Loading from './../../elements/loading';
import InmPagination from "../../elements/widgets/inmPagination";
import SurveysAdd from './../../elements/surveys/widget/surveys_add';
import {confirmAlert} from "react-confirm-alert";

class Surveys extends Component {
	render(){
		return(
			<SurveysList {...this.props}/>
		);
	}

	componentWillMount(){
		const { surveys } = this.props;
		this.props.surveysShow(surveys.pages.current);
	}
}

class SurveysList extends Component {
	render() {
		const { surveys } = this.props;
		return (
			<div>
				{surveys.isFetching ? <Loading /> :
					<table className={`inm-table`}>
						<thead>
						<tr>
							<th>ID</th>
							<th>Encuesta</th>
							<th>Estatus</th>
						</tr>
						</thead>
						<tbody>
						{_.map(surveys.list, (row, k) => {
							return (
								<tr key={k}>
									<td style={{width:10+'%'}}>
										<div className="actions">
											<NavLink to={`/encuestas/editar/${row.id}`}><i className="fa fa-edit"></i></NavLink>
											<button onClick={() => this._getConfirm(row.id, row.name)}><i className="fa fa-trash-o"></i></button>
										</div>
										{row.id}
									</td>
									<td><strong>{row.name}</strong></td>
									<td><strong className={row.status && row.status.style ? `has-text-${row.status.style}`:''}>{row.status && row.status.name ? row.status.name:'---'}</strong></td>
								</tr>
							)
						})}
						</tbody>
					</table>}
				{surveys.pages.total>20 &&
				<InmPagination key="concepts-pages" current={surveys.pages.current} total={surveys.pages.total} nextPage={this._handlePageChange}/>}
			</div>
		)
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_handlePageChange(value) {
		this.props.surveysShow(value);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar la version "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.surveyDelete(id)
		})
	}
}

//export default BaseLayout(Surveys, {title: `Administrar Encuestas`, subnav: {icon: 'fa-clipboard', name: 'Encuestas', actions: {url: '/encuestas/crear', name: 'Agregar encuesta'}}});
export default BaseLayout(Surveys, {
	title: `Administrar Encuestas`,
	subnav: {
		icon: 'fa-clipboard',
		name: 'Administracion',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <SurveysAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/surveys/index.jsx